module.exports = __webpack_public_path__ + "landlord-1-383b3048c27757149085ffd765acf961.bundle.svg";